import React from 'react';
import fr from 'facet-rest';
import { IncludedRelationshipProvider } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Container from './Container';

const TabContent = ({ tabResource }) => {
  return (
    <IncludedRelationshipProvider
      relationship={tabResource.relationship(fr.relationships.tabData.name)}
    >
      <Container />
    </IncludedRelationshipProvider>
  );
};

TabContent.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default TabContent;
